import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListsTableComponent } from './lists-table/lists-table.component';
import { SavedChartsComponent } from './saved-charts/saved-charts.component';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ToolboxModule } from '../shared/toolbox/toolbox.module';
import { ListsDialogsComponent } from './lists-dialogs/lists-dialogs.component';
import { ReactiveFormsModule } from '@angular/forms';
import {LoaderComponent} from '../shared/toolbox/loader/loader.component';
import {ChartWrapperComponent} from '../shared/toolbox/charts/chart-wrapper/chart-wrapper.component';
import { MatIconModule } from '@angular/material/icon';
import { ChartCompSelectionWrapperComponent } from './chart-comp-selection-wrapper/chart-comp-selection-wrapper.component';
import {DashboardComponent} from "../profiles/dashboard/dashboard.component";
import {ProfilesModule} from "../profiles/profiles.module";
import {LbChartWrapperComponent} from "../lbarometer/toolbox/charts/lb-chart-wrapper/lb-chart-wrapper.component";
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    ListsTableComponent,
    SavedChartsComponent,
    ListsDialogsComponent,
    ChartCompSelectionWrapperComponent,
  ],
  imports: [
    ChartWrapperComponent,
    LoaderComponent,
    CommonModule,
    MatTableModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    FormsModule,
    ToolboxModule,
    ReactiveFormsModule,
    DashboardComponent,
    ProfilesModule,
    LbChartWrapperComponent,
    DragDropModule
  ],
  exports: [ListsTableComponent, SavedChartsComponent, ListsDialogsComponent, ChartCompSelectionWrapperComponent],
})
export class ListsModule {}
